import { Field, Form, Formik } from "formik";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import noImage from "../../../assets/Images/body-bg.jpg";
import {
  autoCalculateBasicAndTaxAmount,
  autoCalculateBasicPriceExcludingAndTaxAmount,
  calculateItemPriceAfterDiscount,
  calculateSummary,
  formatNumberWithCommas,
  getOptionNameFromServiceName
} from "../../../constants/constants";
import { serviceTypeEnum } from "../../../constants/enums/service-type-enum";
import userTypeEnum from "../../../constants/enums/user-type-enum";
import { useStore } from "../../../contexts/store-provider";
import {
  getBusinessTypeIdFromLocalStorage,
  getUserTypeFromLocalStorage,
} from "../../../helpers/localstorage-helper";
import { IOption } from "../../../models/ICommon";
import {
  IAddSaleItemVM,
  IDiscountType,
  ISaleItemVM,
  ISaleRecordList,
} from "../../../models/response/ISMRResponse";
import FormikDateFieldMUI from "../../../shared-components/FormikFormHandlers/FormikDateFieldMUI";
import FormikFormSelect from "../../../shared-components/FormikFormHandlers/FormikFormSelect";
import FormikFormTimePicker from "../../../shared-components/FormikFormHandlers/FormikFormTimePicker";
import { addUpdateSaleRecordValidationSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import LoaderButton from "../../../shared-components/button/loader-button";
import Label from "../../../shared-components/label/label";
import AddPopupHOC from "../../../shared-components/popup/add/add-popup-hoc";
import BarcodeScannerPopupHOC from "../../../shared-components/popup/barcode-scanner-popup-hoc/barcode-scanner-popup-hoc";
import DeletePopup from "../../../shared-components/popup/delete/delete-popup";
import DeletePopupHOC from "../../../shared-components/popup/delete/delete-popup-hoc";
import DiscountPopupHOC from "../../../shared-components/popup/discount/discount-popup-hoc";
import { formatMessage } from "../../../translations/format-message";
import BarcodeScannerModal from "../../master-management/product-list/forms/barcode-scanner-modal";
import DeleteSMRCancelForm from "../components/delete-smr-cancel-form";
import SaleRecordPaymentInvoice from "../components/sale-record-payment-invoice";
import AccountingPopupHOC from "../hoc/accounting-popup-hoc";
import RefundPopupHOC from "../hoc/refund-popup-hoc";
import Accounting from "./accounting-form";
import "./accounting-form.css";
import AddEditDiscount from "./add-edit-discount-form";
import AddSMRProductForm from "./add-product-form";
import AddSMRTreatmentForm from "./add-treatment-form";
import moment from "moment";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";

interface IProps {
  smrId: number;
  initialValues: ISaleRecordList;
  getAllStaffOptions: IOption[];
  submitHandler: (values: any, id: number, smrId: number, showAccountingPopup?: boolean) => void;
  customerId: number;
  storeId: number;
  isDisabled: boolean;
  viewOnly: boolean;
  showRefundPopup: boolean;
  refundPopupToggleHandler: () => void;
  showAccountingPopup: boolean;
  accountingPopupToggleHandler: () => void;
  showBarcodeScannerPopup: boolean;
  barcodescannerPopupToggleHandler: () => void;
  showDeletePopup: boolean;
  deletePopupToggleHandler: () => void;
  showAddPopup: boolean;
  addToggleHandler: () => void;
  showDiscountPopup: boolean;
  discountToggleHandler: () => void;
  shouldPreventScroll?: React.MutableRefObject<boolean>;
}
const AddEditSaleRecordForm = (props: IProps) => {

  const location: any = useLocation();
  const { isDisabled, viewOnly } = props;
  const { smrStore, headquarterStore, masterManagementStore } = useStore();
  const { headquarterIcons } = headquarterStore;
  const { consumptioTaxSetting } = masterManagementStore;
  const {
    allSalesRecord,
    registerSale,
    DeleteSaleRecordService,
    DeleteSMRService,
    deleteSaleRecordState,
    deleteSMRState,
    RefundSaleRecordService,
    refundSaleRecordState,
    setSelectedSaleRecrodForCreatingNewSale,
    selectedSaleRecrodForCreatingNewSale,
    GetProductManagementByStoreIdAndBarcodeService,
    productBarcode,
    productBarcodeState,
    resetProductBarcodeState,
    setSelectedAppointmentIdForPayment,
    selectedAppointmentIdForPayment,
    selectedBookingId,
    setIsDataChanged,
    isDataChanged,
    addUpdateSaleRecordState,
    resetAddUpdateSaleRecordState,
    openAccountHandler,
    setOpenAccountHandler,
    openAccountingPopupSaleRecordId,
    setOpenAccountingPopupSaleRecordId,
    resetSalesRecordListState
  } = smrStore;

  let openAccounting =
    (location.state && location.state?.openAccounting) || false;

  const [saleRecord, setSaleRecord] = useState<ISaleRecordList>(
    props.initialValues
  );

  const [saleItemList, setSaleItemList] = useState<IAddSaleItemVM[]>(
    props.initialValues.SaleItem
  );
  const [selectedDiscountInfo, setSelectedDiscountInfo] = useState<any>({
    itemType: 0,
    index: -1,
    saleItem: 0,
    isOverall: false,
  });

  const [saleItemType, setSaleItemType] = useState<number>(0);

  const [overAllDiscountDetail, setOverAllDiscountDetail] =
    useState<IDiscountType>({
      DiscountType: props.initialValues.DiscountType,
      DiscountPercent: props.initialValues.DiscountPercent,
      DiscountCash: props.initialValues.DiscountCash,
    });
  useEffect(() => {
    return (() => {
      setSaleItemType(0);
      setSelectedDiscountInfo({
        itemType: 0,
        index: -1,
        saleItem: 0,
        isOverall: false,
      })
    });
  }, [selectedBookingId]);

  const [showScanner, setShowScanner] = useState(false);
  const [isAddAccounting, setIsAddAccounting] = useState(false);

  const resetValuesToInitial = () =>{
    setIsDataChanged(false)
    setSaleRecord(props.initialValues);
    setSaleItemList(props.initialValues.SaleItem);
    setSaleItemType(0);
    setSelectedDiscountInfo({
      itemType: 0,
      index: -1,
      saleItem: 0,
      isOverall: false,
    });
    setOverAllDiscountDetail({
      DiscountType: props.initialValues.DiscountType,
      DiscountPercent: props.initialValues.DiscountPercent,
      DiscountCash: props.initialValues.DiscountCash,
    })
  }
  const mapTreatmentsWithOptions = () => {
    const treatments = saleItemList.filter(
      (item) => item.ItemType === serviceTypeEnum.Treatment
    );
    const options = saleItemList.filter(
      (item) => item.ItemType === serviceTypeEnum.Option
    );

    return treatments.map((treatment) => {
      const optionIds = options
        .filter((option) => option.ItemName?.startsWith(`${treatment.ItemId}_`))
        .map((option) => option.ItemId);

      return {
        TreatmentId: treatment.ItemId,
        OptionIds: optionIds,
      };
    });
  };

  const mapTreatmentsWithOptionsAndTime = () => {
    const treatments = saleItemList.filter(
      (item) => item.ItemType === serviceTypeEnum.Treatment
    );

    const options = saleItemList.filter(
      (item) => item.ItemType === serviceTypeEnum.Option
    );

    return treatments.map((treatment) => {
      const relatedOptions = options
        .filter((option) => option.ItemName?.startsWith(`${treatment.ItemId}_`))
        .map((option) => ({
          OptionId: option.ItemId,
          TimeValue: option.TimeValue,
        }));

      return {
        TreatmentId: treatment.ItemId,
        TreatmentTimeValue: treatment.TimeValue,
        Options: relatedOptions,
      };
    });
  };


  useEffect(() => {
    setSaleRecord(props.initialValues);
    setSaleItemList(props.initialValues.SaleItem);
    setOverAllDiscountDetail({
      DiscountType: props.initialValues.DiscountType,
      DiscountPercent: props.initialValues.DiscountPercent,
      DiscountCash: props.initialValues.DiscountCash,
    });
  }, [allSalesRecord]);

  useEffect(() => {
    if (refundSaleRecordState.success) {
      props.refundPopupToggleHandler();
    }
  }, [refundSaleRecordState.success]);

  useEffect(() => {
    if (productBarcodeState.success && productBarcode) {
      const alreadyExists = saleItemList.some(
        (item) => item.ItemId === productBarcode.ItemId
      );
      if (!alreadyExists) {
        setSaleItemList((prev: IAddSaleItemVM[]) => {
          let tempTreatmentList = [...prev];
          tempTreatmentList.push({ ...productBarcode });
          return [...tempTreatmentList];
        });
        setIsDataChanged(true);
        toast.success(formatMessage("added_success"));
      } else toast.error(formatMessage("product_is_already_added"));
      resetProductBarcodeState();
    }
  }, [productBarcodeState.success]);

  const handleRemoveDiscount = () => {
    setIsDataChanged(true);
    setOverAllDiscountDetail({
      DiscountType: 0,
      DiscountPercent: 0,
      DiscountCash: 0,
    });
  };
  const addSaleItemClickHandler = () => {
    props.addToggleHandler();
  };

  const addSaleItemSubmitHandler = (treatments: any[]) => {
    setSaleItemList((prev: IAddSaleItemVM[]) => {
      let tempTreatmentList = [...prev];
      return [...tempTreatmentList, ...treatments];
    });
    setIsDataChanged(true);
  };

  const addEditDiscountClickHandler = (
    itemType: number,
    index: number | string,
    saleItem: any,
    isOverall: boolean = false
  ) => {
    if (!isOverall)
      setSelectedDiscountInfo({ itemType, index, saleItem, isOverall });
    else {
      setSelectedDiscountInfo({
        itemType,
        index,
        isOverall,
        saleItem: {
          DiscountType: overAllDiscountDetail.DiscountType,
          DiscountCash: overAllDiscountDetail.DiscountCash,
          DiscountPercent: overAllDiscountDetail.DiscountPercent,
        },
      });
    }
    props.discountToggleHandler();
  };

  const addEditDiscountSubmitHandler = (values: any) => {
    if (selectedDiscountInfo.isOverall) {
      setOverAllDiscountDetail((prev: any) => {
        const tempSaleRecord = { ...prev };
        tempSaleRecord.DiscountType = values.DiscountType;
        tempSaleRecord.DiscountCash = values.DiscountCash;
        tempSaleRecord.DiscountPercent = values.DiscountPercent;
        return tempSaleRecord;
      });
    } else {
      setSaleItemList((prev: IAddSaleItemVM[]) => {
        let tempArray = [...prev];
        let filteredTreatmentItemList = tempArray.filter(
          (item: any) => item.ItemType === serviceTypeEnum.Treatment
        );
        let filteredProductItemList = tempArray.filter(
          (item: any) => item.ItemType === serviceTypeEnum.Product
        );
        let filteredOptionItemList = tempArray.filter(
          (item: any) => item.ItemType === serviceTypeEnum.Option
        );
        if (selectedDiscountInfo.itemType === serviceTypeEnum.Treatment) {
          filteredTreatmentItemList[selectedDiscountInfo.index].ItemType =
            selectedDiscountInfo.itemType;
          filteredTreatmentItemList[selectedDiscountInfo.index].DiscountType =
            values.DiscountType;
          filteredTreatmentItemList[selectedDiscountInfo.index].DiscountCash =
            values.DiscountCash;
          filteredTreatmentItemList[
            selectedDiscountInfo.index
          ].DiscountPercent = values.DiscountPercent;
        } else if (selectedDiscountInfo.itemType === serviceTypeEnum.Option) {
          const editDataIndex = filteredOptionItemList.findIndex(
            (item) =>
              item.ItemId === selectedDiscountInfo.saleItem.ItemId
          );
          if (editDataIndex > -1) {
            filteredOptionItemList[editDataIndex].ItemType =
              selectedDiscountInfo.itemType;
            filteredOptionItemList[editDataIndex].DiscountType =
              values.DiscountType;
            filteredOptionItemList[editDataIndex].DiscountCash =
              values.DiscountCash;
            filteredOptionItemList[editDataIndex].DiscountPercent =
              values.DiscountPercent;
          }

        }
        else {
          filteredProductItemList[selectedDiscountInfo.index].ItemType =
            selectedDiscountInfo.itemType;
          filteredProductItemList[selectedDiscountInfo.index].DiscountType =
            values.DiscountType;
          filteredProductItemList[selectedDiscountInfo.index].DiscountCash =
            values.DiscountCash;
          filteredProductItemList[selectedDiscountInfo.index].DiscountPercent =
            values.DiscountPercent;
        }

        return [
          ...filteredTreatmentItemList,
          ...filteredProductItemList,
          ...filteredOptionItemList,
        ];
      });
    }
    setSelectedDiscountInfo({
      itemType: serviceTypeEnum.Treatment,
      index: -1,
      saleItem: 0,
      isOverall: false,
    });
    setIsDataChanged(true);
    props.discountToggleHandler();
  };

  const deleteClickHandler = () => {
    props.deletePopupToggleHandler();
  };

  const deleteHandler = (values: any) => {
    if (allSalesRecord?.length === 1)
      DeleteSMRService(props.deletePopupToggleHandler, Number(values.CancellationType));
    else
      DeleteSaleRecordService(saleRecord.Id, props.deletePopupToggleHandler, allSalesRecord[1]?.Id);
  };

  const refundClickHandler = () => {
    props.refundPopupToggleHandler();
  };

  const refundHandler = () => {
    if (refundSaleRecordState.inProgress) return;
    // Prevent auto-scroll when refunding
    if (props.shouldPreventScroll) {
      props.shouldPreventScroll.current = true;
    }
    RefundSaleRecordService(saleRecord.SMRId, {...saleRecord, StoreId: props.storeId});
  };


  const accountingClickHandler = () => {
    props.accountingPopupToggleHandler();
  };

  const isFutureDateOnly = (dateStr: string): boolean => {
    const today = new Date();
    const inputDate = new Date(dateStr);

    // Normalize both dates to midnight for comparison (removes time part)
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    return inputDate > today;
  };

  const accountingpopupCloseHandler = () => {
    setIsDataChanged(false);
    setIsAddAccounting(false);
    props.accountingPopupToggleHandler();
  };

  const openScanner = () => {
    setShowScanner(true);
  };

  const closeScanner = () => {
    setShowScanner(false);
  };

  const handleBarcodeScanned = (barcode: string, formValues: any) => {
    GetProductManagementByStoreIdAndBarcodeService(
      props.storeId,
      barcode,
      formValues
    );
    setShowScanner(false);
  };

  const deleteProductSaleItemHandler = (index: number) => {
    setSaleItemList((prev: any) => {
      let tempArray = [...prev];
      let filteredTreatmentItemList = tempArray.filter(
        (item: any) => item.ItemType === serviceTypeEnum.Treatment
      );
      let filteredProductItemList = tempArray.filter(
        (item: any) => item.ItemType === serviceTypeEnum.Product
      );
      filteredProductItemList.splice(index, 1);

      return [...filteredTreatmentItemList, ...filteredProductItemList];
    });
    setIsDataChanged(true);
  };
  const deleteTreatmentSaleItemHandler = (index: number, itemId: number) => {
    setSaleItemList((prev: IAddSaleItemVM[]) => {
      const treatmentItems = prev.filter(
        (item) => item.ItemType === serviceTypeEnum.Treatment
      );
      const productItems = prev.filter(
        (item) => item.ItemType === serviceTypeEnum.Product
      );
      const optionItems = prev.filter(
        (item) => item.ItemType === serviceTypeEnum.Option
      );
      treatmentItems.splice(index, 1);
      const filteredOptionItems = optionItems.filter(
        (item) => !item.ItemName?.startsWith(`${itemId}_`)
      );
      return [...treatmentItems, ...productItems, ...filteredOptionItems];
    });

    setIsDataChanged(true);
  };

  const deleteOptionSaleItemHandler = (
    treatmentId: number,
    optionItemId: number
  ) => {
    setSaleItemList((prev: IAddSaleItemVM[]) => {
      const treatmentItems = prev.filter(
        (item) => item.ItemType === serviceTypeEnum.Treatment
      );
      const productItems = prev.filter(
        (item) => item.ItemType === serviceTypeEnum.Product
      );
      const optionItems = prev.filter(
        (item) => item.ItemType === serviceTypeEnum.Option
      );
      const index = optionItems.findIndex(
        (item) =>
          item.ItemName?.startsWith(`${treatmentId}_`) &&
          item.ItemId === optionItemId
      );
      optionItems.splice(index, 1);
      return [...treatmentItems, ...productItems, ...optionItems];
    });

    setIsDataChanged(true);
  };

  const newSaleClickHandler = (id: number) => {
    setIsDataChanged(true);
    // Prevent auto-scroll when creating new sale from refunded record
    if (props.shouldPreventScroll) {
      props.shouldPreventScroll.current = true;
    }
    setSelectedSaleRecrodForCreatingNewSale(id);
  };

  const saleRecordSubmitHandler = (values: ISaleRecordList, showAccountingPopup: boolean = false) => {
    let paymentSummary = calculateSummary(
      { StaffId: values.StaffId, IsNominationApplied: values.IsNominationApplied },
      saleItemList,
      props.getAllStaffOptions,
      consumptioTaxSetting,
      overAllDiscountDetail,
      true,
      saleRecord.NominationFee
    );
    let tempvalues: any = {
      AppointmentId: values.AppointmentId,
      PaymentType: 0,
      DiscountType: overAllDiscountDetail.DiscountType,
      DiscountCash: overAllDiscountDetail.DiscountCash,
      DiscountPercent: overAllDiscountDetail.DiscountPercent,
      SMRGeneratedDate: moment(values.Date).format("YYYY-MM-DD ") + moment(values.Time, "HH:mm:ss").format("HH:mm"),
      Date: values.Date,
      Time: values.Time,
      StaffId: values.StaffId,
      IsNominationApplied: values.IsNominationApplied,
      ConsumptionTax: paymentSummary.ConsumptionTax,
      NominationFee: paymentSummary.NominationFee,
      IsActiveRecord: true,
      Total: paymentSummary.TotalAmount,
      IsChanged: true,
      SalesItemDetails: saleItemList,
      TaxTotal: paymentSummary.TaxTotal,
    };
    tempvalues.IsNominationApplied = !values.IsNominationApplied ? saleItemList.some(
      (item) => item.StaffId === values.StaffId && item.IsNominationApplied
      ) : values.IsNominationApplied;
    if (!registerSale && selectedSaleRecrodForCreatingNewSale === -1)
      tempvalues.IsStaffChanged = saleRecord.StaffId !== values.StaffId;
    if(showAccountingPopup)
      props.submitHandler(tempvalues, values.Id, saleRecord.SMRId, showAccountingPopup);
    else
      props.submitHandler(tempvalues, values.Id, saleRecord.SMRId);
  };

  useEffect(() => {
      if (addUpdateSaleRecordState.success) {
        if(openAccountHandler && saleRecord.Id === openAccountingPopupSaleRecordId){
          props.accountingPopupToggleHandler();
          setOpenAccountHandler(false);
        }
        else{
          resetSalesRecordListState();
        }
        resetAddUpdateSaleRecordState();
        setIsDataChanged(false);
      }
    }, [addUpdateSaleRecordState.success, openAccountHandler]);

  return (
    <>
      {props.showDeletePopup && (
        <DeleteSMRCancelForm
          title="delete_sales_record"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          isReservationSales={saleRecord.AppointmentId > 0}
          message="message_delete_sales_record_confirm"
          isLoading={deleteSaleRecordState.inProgress || deleteSMRState.inProgress}
        />
      )}
      {props.showRefundPopup &&
          saleRecord.IsActiveRecord &&
          saleRecord.SaleRecordPaymentStatus === true &&
          saleRecord.PaymentType === 1 && (
            <DeletePopup
              title="refund_confirm"
              modalSubmit={refundHandler}
              modalClosed={props.refundPopupToggleHandler}
              message="message_refund_sales_record_confirm"
              isLoading={refundSaleRecordState.inProgress}
            />
          )}
      <Formik
        initialValues={saleRecord}
        enableReinitialize
        validateOnBlur={false}
        validationSchema={addUpdateSaleRecordValidationSchema}
        onSubmit={async (values) => {
          saleRecordSubmitHandler(values);
        }}
      >
        {({ dirty, values, resetForm }) => {
          if ((props.initialValues.StaffId != values.StaffId || props.initialValues.IsNominationApplied != values.IsNominationApplied)  && !isDataChanged) {
            setIsDataChanged(true);
          }
          if(smrStore.isRegisterButtonClicked){
            resetForm();
            resetValuesToInitial();
            smrStore.setIsRegisterButtonClicked(false);
          }
          return (
            <>
              {props.showAccountingPopup && (
                <Accounting
                  saleRecordItem={saleRecord}
                  isDataChanged={isDataChanged}
                  consumptionTax={consumptioTaxSetting}
                  overAllDiscountDetails={overAllDiscountDetail}
                  getAllStaffOptions={props.getAllStaffOptions}
                  smrId={props.smrId}
                  saleRecordId={saleRecord.Id}
                  customerId={props.customerId}
                  storeId={props.storeId}
                  saleItems={saleItemList}
                  isAddAccounting={isAddAccounting}
                  formValues={values}
                  allSalesRecord={allSalesRecord}
                  //this condition tells that the sale record is refunded
                  isDisabled={(saleRecord.IsActiveRecord === false)}
                  modalClosed={accountingpopupCloseHandler}
                />
              )}
              {props.showAddPopup &&
                saleItemType === serviceTypeEnum.Treatment && (
                  <AddSMRTreatmentForm
                    storeId={props.storeId}
                    initialValue={mapTreatmentsWithOptions()}
                    initialServicesTimeValue={mapTreatmentsWithOptionsAndTime()}
                    formValues={values}
                    saleItemList={saleItemList}
                    setSaleItemList={setSaleItemList}
                    submitHandler={(saleItems: any[]) => {
                      addSaleItemSubmitHandler(saleItems);
                    }}
                    openPanel={props.showAddPopup}
                    modalClosed={props.addToggleHandler}
                    businessTypeId={
                      userTypeEnum[userTypeEnum.Store] ===
                        getUserTypeFromLocalStorage()
                        ? getBusinessTypeIdFromLocalStorage()
                        : -1
                    }
                  />
                )}
              {props.showAddPopup &&
                saleItemType === serviceTypeEnum.Product && (
                  <AddSMRProductForm
                    storeId={props.storeId}
                    formValues={values}
                    saleItemIds={saleItemList
                      ?.filter(
                        (item) => item.ItemType === serviceTypeEnum.Product
                      )
                      ?.map((item) => item.ItemId)}
                    submitHandler={(saleItems: any[]) => {
                      addSaleItemSubmitHandler(saleItems);
                    }}
                    openPanel={props.showAddPopup}
                    modalClosed={props.addToggleHandler}
                  />
                )}
              {props.showDiscountPopup && (
                <AddEditDiscount
                  selectedItemDiscountDetails={selectedDiscountInfo}
                  paymentSummary={calculateSummary(
                    { StaffId: values.StaffId, IsNominationApplied: values.IsNominationApplied },
                    saleItemList,
                    props.getAllStaffOptions,
                    consumptioTaxSetting,
                    overAllDiscountDetail
                  )}
                  submitHandler={addEditDiscountSubmitHandler}
                  modalClosed={props.discountToggleHandler}
                />
              )}
              <BarcodeScannerModal
                show={showScanner}
                onClose={closeScanner}
                onScan={(barcode) => handleBarcodeScanned(barcode, values)}
              />
              <Form className={`user-form sales-accounting-form ${saleRecord.SaleRecordPaymentStatus === true && saleRecord.PaymentType === 0 ? "refunded-form" : ""} `}>
                <div className="px-3">
                  { (addUpdateSaleRecordState.inProgress || refundSaleRecordState.inProgress || deleteSaleRecordState.inProgress) &&
                    <FormLoader loading={addUpdateSaleRecordState.inProgress || refundSaleRecordState.inProgress || deleteSaleRecordState.inProgress} />
                  }
                  {/* Header */}

                  <div className="d-flex align-items-center sales_header">
                    {/* Date Input */}
                    <div className="d-xxl-flex align-items-center">
                      <Label
                        className="label-style"
                        required={true}
                        label="date"
                      />
                      <Field
                        name="Date"
                        as={FormikDateFieldMUI}
                        disableFuture={false}
                        localStateUpdate={()=>{setIsDataChanged(true)}}
                        disabled={viewOnly ? viewOnly : (saleRecord.AppointmentId > 0 ? true : isDisabled)}
                      />
                    </div>

                    {/* Time Input */}
                    <div className="d-xxl-flex align-items-center ms-3">
                      <Label
                        className="label-style"
                        required={true}
                        label="time_label"
                      />
                      <Field
                        name="Time"
                        as={FormikFormTimePicker}
                        localStateUpdate={()=>{setIsDataChanged(true)}}
                        disabled={viewOnly ? viewOnly : (saleRecord.AppointmentId > 0 ? true : isDisabled)}
                      />
                    </div>

                    {/* Staff Dropdown */}
                    <div className="d-xxl-flex align-items-center ms-3">
                      <Label
                        className="label-style"
                        required={true}
                        label="staff"
                      />
                      <Field
                        name="StaffId"
                        getData={false}
                        options={props.getAllStaffOptions}
                        as={FormikFormSelect}
                        disabled={viewOnly ? viewOnly : isDisabled}
                      />
                    </div>

                    {/* Toggle Switch */}
                    <div className="switchBox ms-3">
                      <div className="form-check form-switch d-flex align-items-center">
                        <Field
                          data-testid="testRememberMe"
                          className="form-check-input"
                          name="IsNominationApplied"
                          type="checkbox"
                          id="IsNominationApplied"
                          disabled={viewOnly ? viewOnly : isDisabled}
                        />
                        <label
                          htmlFor="IsNominationApplied"
                          className="form-check-label ms-2"
                        >
                          <FormattedMessage id="nomination_fee" />
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Sales Table */}
                  {
                    <div className="py-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h3 className="mb-0">
                          <FormattedMessage id="treatment" />{" "}
                          <img
                            src={headquarterIcons.TreatmentIcon || noImage}
                            alt="icon"
                            className="badge_icon"
                          />
                        </h3>
                        <button
                          className="btn btn-outline-primary"
                          type="button"
                          disabled={viewOnly ? viewOnly : isDisabled}
                          onClick={() => {
                            setSaleItemType(serviceTypeEnum.Treatment);
                            addSaleItemClickHandler();
                          }}
                        >
                          <i className="bi bi-plus-lg me-1"></i>{" "}
                          <FormattedMessage id="addition" />
                        </button>
                      </div>
                      <table className="table table-bordered align-middle">
                        <thead>
                          <tr>
                            <th>
                              <FormattedMessage id="treatment_name" />
                            </th>
                            <th>
                              <FormattedMessage id="price_excluding_tax" />
                            </th>
                            <th>
                              <FormattedMessage id="tax" />
                            </th>
                            <th>
                              <FormattedMessage id="sub_total" />
                            </th>
                            <th>
                              <FormattedMessage id="discount" />
                            </th>
                            <th>
                              <FormattedMessage id="responsible" />
                            </th>

                            <th></th>
                          </tr>
                        </thead>

                        <tbody>

                          {saleItemList &&
                            saleItemList?.length > 0 &&
                            saleItemList
                              ?.filter(
                                (saleItem: ISaleItemVM) =>
                                  saleItem.ItemType ===
                                  serviceTypeEnum.Treatment
                              )
                              ?.map((item: any, index: number) => {
                                const itemPriceAfterDiscount = calculateItemPriceAfterDiscount(item);
                                // const itemBasicAndTaxAmount =
                                //   autoCalculateBasicPriceExcludingAndTaxAmount(
                                //     itemPriceAfterDiscount,
                                //     item.Tax
                                //   );
                                const selectedOptions = saleItemList.reduce(
                                  (
                                    acc: ISaleItemVM[],
                                    optionItem: ISaleItemVM
                                  ) => {
                                    if (
                                      optionItem.ItemType ===
                                      serviceTypeEnum.Option
                                    ) {
                                      const [id, name] =
                                        optionItem.ItemName.split("_");
                                      if (id === item.ItemId.toString()) {
                                        acc.push({
                                          ...optionItem,
                                          ItemName:
                                            getOptionNameFromServiceName(
                                              optionItem.ItemName
                                            ),
                                        });
                                      }
                                    }
                                    return acc;
                                  },
                                  []
                                );

                                return (
                                  <>
                                    <tr key={"treatment" + index}>
                                      <td>{item.ItemName}</td>
                                      <td>
                                        <i className="bi bi-currency-yen me-1"></i>
                                        {formatNumberWithCommas(item.Price - item.TaxAmount)}
                                      </td>
                                      <td>
                                        <i className="bi bi-currency-yen me-1"></i>
                                        {formatNumberWithCommas(item.TaxAmount)} (
                                        {item.Tax}%)
                                      </td>
                                      <td>
                                        <i className="bi bi-currency-yen me-1"></i>
                                        {formatNumberWithCommas(itemPriceAfterDiscount*item.Quantity)}
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          disabled={
                                            viewOnly ? viewOnly : isDisabled
                                          }
                                          onClick={() =>
                                            addEditDiscountClickHandler(
                                              serviceTypeEnum.Treatment,
                                              index,
                                              item
                                            )
                                          }
                                          className="btn btn-link text-primary"
                                        >
                                          {item.DiscountType == 0 && (
                                            <>{item.DiscountPercent} %</>
                                          )}
                                          {item.DiscountType == 1 && (
                                            <><i className="bi bi-currency-yen me-1"></i>{formatNumberWithCommas(item.DiscountCash)}</>
                                          )}
                                          {item.DiscountType == 2 && (
                                            <>
                                              {item.DiscountPercent} % ,{" "}
                                              <><i className="bi bi-currency-yen me-1"></i>{formatNumberWithCommas(item.DiscountCash)}</>
                                            </>
                                          )}
                                        </button>
                                      </td>
                                      <td>
                                        <select
                                          className="ms-1 form-select max-input"
                                          value={item.StaffId}
                                          disabled={viewOnly ? viewOnly : isDisabled}
                                          onChange={(e: any) => {
                                            let selectedValue = parseInt(e.target.value) || 0;
                                            if (selectedValue) {
                                              setSaleItemList((prev: IAddSaleItemVM[]) => {
                                                let tempArray = [...prev];
                                                let filteredTreatmentItemList = tempArray.filter(
                                                  (item: any) => item.ItemType === serviceTypeEnum.Treatment
                                                );
                                                let filteredProductItemList = tempArray.filter(
                                                  (item: any) => item.ItemType !== serviceTypeEnum.Treatment
                                                );
                                                filteredTreatmentItemList[index].StaffId = selectedValue;
                                                return [
                                                  ...filteredTreatmentItemList,
                                                  ...filteredProductItemList,
                                                ];
                                              });
                                              setIsDataChanged(true);
                                            }
                                          }}
                                        >
                                          {props.getAllStaffOptions.map(
                                            (op: IOption) => (
                                              <option
                                                key={op.id}
                                                value={op.id}
                                              >
                                                {op.label}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </td>
                                      <td className="text-end d-flex align-items-center justify-content-end">
                                        {!viewOnly && (
                                          <div className="btn-group">
                                            <button
                                              type="button"
                                              className="btn btn-outline-danger"
                                              disabled={isDisabled}
                                              onClick={() => {
                                                deleteTreatmentSaleItemHandler(
                                                  index,
                                                  item.ItemId
                                                );
                                              }}
                                            >
                                              <i className="bi bi-trash"></i>
                                            </button>
                                          </div>
                                        )}
                                        <div className="ms-3">
                                          <label className="me-2">
                                            <FormattedMessage id="nominate" />
                                          </label>

                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={
                                                item.IsNominationApplied
                                              }
                                              disabled={
                                                viewOnly
                                                  ? viewOnly
                                                  : isDisabled
                                              }
                                              onChange={(e: any) => {
                                                let value = e.target.checked;
                                                setSaleItemList(
                                                  (
                                                    prev: IAddSaleItemVM[]
                                                  ) => {
                                                    let tempArray = [...prev];
                                                    let filteredTreatmentItemList =
                                                      tempArray.filter(
                                                        (item: any) =>
                                                          item.ItemType ===
                                                          serviceTypeEnum.Treatment
                                                      );
                                                    let filteredProductItemList =
                                                      tempArray.filter(
                                                        (item: any) =>
                                                          item.ItemType !==
                                                          serviceTypeEnum.Treatment
                                                      );
                                                    filteredTreatmentItemList[
                                                      index
                                                    ].IsNominationApplied =
                                                      value;
                                                    return [
                                                      ...filteredTreatmentItemList,
                                                      ...filteredProductItemList,
                                                    ];
                                                  }
                                                );
                                                setIsDataChanged(true);
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                    {selectedOptions.map(
                                      (option: any, index2: number) => {
                                        // const optionItemBasicAndTaxAmount =
                                        //   autoCalculateBasicAndTaxAmount(
                                        //     option.Price,
                                        //     option.TaxAmount
                                        //   );
                                        const optionPriceAfterDiscount = calculateItemPriceAfterDiscount(option);
                                        const optionIndex = index2 + " " + item.ItemId;
                                        return (
                                          <tr key={optionIndex}>
                                            <td>{option.ItemName}
                                              <span className="badge bg-primary rounded ms-2">
                                                <FormattedMessage id="option" />
                                              </span>
                                            </td>
                                            <td>
                                              <i className="bi bi-currency-yen me-1"></i>
                                              {
                                                formatNumberWithCommas(option.Price - option.TaxAmount)
                                              }
                                            </td>
                                            <td>
                                              <i className="bi bi-currency-yen me-1"></i>
                                              {
                                                formatNumberWithCommas(option.TaxAmount)
                                              }{" "}
                                              ({option.Tax}%)
                                            </td>

                                            <td>
                                              <i className="bi bi-currency-yen me-1"></i>
                                              {formatNumberWithCommas(optionPriceAfterDiscount*option.Quantity)}
                                            </td>
                                            <td>
                                              <button
                                                type="button"
                                                disabled={
                                                  viewOnly ? viewOnly : isDisabled
                                                }
                                                onClick={() =>
                                                  addEditDiscountClickHandler(
                                                    serviceTypeEnum.Option,
                                                    optionIndex,
                                                    option
                                                  )
                                                }
                                                className="btn btn-link text-primary"
                                              >
                                                {option.DiscountType == 0 && (
                                                  <>{option.DiscountPercent} %</>
                                                )}
                                                {option.DiscountType == 1 && (
                                                  <><i className="bi bi-currency-yen me-1"></i>{formatNumberWithCommas(option.DiscountCash)}</>
                                                )}
                                                {option.DiscountType == 2 && (
                                                  <>
                                                    {option.DiscountPercent} % ,{" "}
                                                    <><i className="bi bi-currency-yen me-1"></i>{formatNumberWithCommas(option.DiscountCash)}</>
                                                  </>
                                                )}
                                              </button>
                                            </td>
                                            <td>
                                              <select
                                                className="ms-1 form-select max-input"
                                                value={option.StaffId}
                                                disabled={viewOnly ? viewOnly : isDisabled}
                                                onChange={(e: any) => {
                                                  let selectedValue = parseInt(e.target.value) || 0;
                                                  if (selectedValue) {
                                                    setSaleItemList((prev: IAddSaleItemVM[]) => {
                                                      const treatmentItems = prev.filter(
                                                        (item) => item.ItemType === serviceTypeEnum.Treatment
                                                      );
                                                      const productItems = prev.filter(
                                                        (item) => item.ItemType === serviceTypeEnum.Product
                                                      );
                                                      const optionItems = prev.filter(
                                                        (item) => item.ItemType === serviceTypeEnum.Option
                                                      );
                                                      const editDataIndex = optionItems.findIndex(
                                                        (data) => data.ItemId === option.ItemId
                                                      );
                                                      if (editDataIndex > -1) {
                                                        optionItems[editDataIndex].StaffId = selectedValue;
                                                      }
                                                      return [...treatmentItems, ...productItems, ...optionItems];
                                                    });
                                                    setIsDataChanged(true);
                                                  }
                                                }}
                                              >
                                                {props.getAllStaffOptions.map(
                                                  (op: IOption) => (
                                                    <option
                                                      key={op.id}
                                                      value={op.id}
                                                    >
                                                      {op.label}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                            </td>
                                            <td className="text-end d-flex align-items-center justify-content-end">
                                              {!viewOnly && (
                                                <>
                                                  <div className="btn-group">
                                                    <button
                                                      type="button"
                                                      className="btn btn-outline-danger"
                                                      disabled={isDisabled}
                                                      onClick={() => {
                                                        deleteOptionSaleItemHandler(
                                                          item.ItemId,
                                                          option.ItemId
                                                        );
                                                      }}
                                                    >
                                                      <i className="bi bi-trash"></i>
                                                    </button>
                                                  </div>


                                                  <div className="ms-3">
                                                    <label className="me-2">
                                                      <FormattedMessage id="nominate" />
                                                    </label>
                                                    <div className="form-check form-switch">
                                                      <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        checked={
                                                          option.IsNominationApplied
                                                        }
                                                        disabled={
                                                          viewOnly
                                                            ? viewOnly
                                                            : isDisabled
                                                        }
                                                        onChange={(e: any) => {
                                                          let value = e.target.checked;
                                                          setSaleItemList((prev: IAddSaleItemVM[]) => {
                                                            const treatmentItems = prev.filter(
                                                              (item) => item.ItemType === serviceTypeEnum.Treatment
                                                            );
                                                            const productItems = prev.filter(
                                                              (item) => item.ItemType === serviceTypeEnum.Product
                                                            );
                                                            const optionItems = prev.filter(
                                                              (item) => item.ItemType === serviceTypeEnum.Option
                                                            );
                                                            const editDataIndex = optionItems.findIndex(
                                                              (data) =>
                                                                data.ItemId === option.ItemId
                                                            );
                                                            if (editDataIndex > -1)
                                                              optionItems[editDataIndex].IsNominationApplied = value;
                                                            return [...treatmentItems, ...productItems, ...optionItems];
                                                          });
                                                          setIsDataChanged(true);
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                </>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  }

                  {/* Merchandise Table */}
                  <div className="py-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h3 className="mb-0">
                        <FormattedMessage id="merchandise" />{" "}
                        <img
                          src={headquarterIcons.ProductIcon || noImage}
                          alt="icon"
                          className="badge_icon"
                        />
                      </h3>
                      <div className="d-flex align-items-center justify-content-end">
                        <button
                          className="btn btn-primary me-2"
                          type="button"
                          disabled={viewOnly ? viewOnly : isDisabled}
                          onClick={openScanner}
                        >
                          <i className="bi bi-camera-fill"></i>
                        </button>
                        <button
                          className="btn btn-outline-primary"
                          type="button"
                          disabled={viewOnly ? viewOnly : isDisabled}
                          onClick={() => {
                            setSaleItemType(serviceTypeEnum.Product);
                            addSaleItemClickHandler();
                          }}
                        >
                          <i className="bi bi-plus-lg me-1"></i>{" "}
                          <FormattedMessage id="addition" />
                        </button>
                      </div>
                    </div>

                    <table className="table table-bordered align-middle">
                      <thead>
                        <tr>
                          <th>
                            <FormattedMessage id="product_name" />
                          </th>
                          <th>
                            <FormattedMessage id="quantity" />
                          </th>
                          <th>
                            <FormattedMessage id="price_excluding_tax" />
                          </th>
                          <th>
                            <FormattedMessage id="tax" />
                          </th>
                          <th>
                            <FormattedMessage id="sub_total" />
                          </th>
                          <th>
                            <FormattedMessage id="discount" />
                          </th>
                          <th>
                            <FormattedMessage id="responsible" />
                          </th>

                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {saleItemList &&
                          saleItemList?.length > 0 &&
                          saleItemList
                            ?.filter(
                              (saleItem: ISaleItemVM) =>
                                saleItem.ItemType === serviceTypeEnum.Product
                            )
                            ?.map((item: any, index: number) => {
                              const itemPriceAfterDiscount = calculateItemPriceAfterDiscount(item);
                              // const itemBasicAndTaxAmount =
                              //   autoCalculateBasicPriceExcludingAndTaxAmount(
                              //     itemPriceAfterDiscount,
                              //     item.Tax
                              //   );
                              return (
                                <tr key={"product" + index}>
                                  <td>{item.ItemName}</td>
                                  <td>
                                    <input
                                      type="number"
                                      className="form-control max-input"
                                      value={item.Quantity}
                                      min={1}
                                      disabled={viewOnly ? viewOnly : isDisabled}
                                      onChange={(e: any) => {
                                        let selectedValue = e.target.value === '' ? '' : parseInt(e.target.value);
                                        
                                        setSaleItemList((prev: IAddSaleItemVM[]) => {
                                          let tempArray = [...prev];
                                          let filteredTreatmentItemList = tempArray.filter(
                                            (item: any) => item.ItemType !== serviceTypeEnum.Product
                                          );
                                          let filteredProductItemList: any = tempArray.filter(
                                            (item: any) => item.ItemType === serviceTypeEnum.Product
                                          );
                                          filteredProductItemList[index].Quantity = selectedValue === '' ? '' : selectedValue;
                                          return [
                                            ...filteredTreatmentItemList,
                                            ...filteredProductItemList,
                                          ];
                                        });
                                        setIsDataChanged(true);
                                      }}
                                      onBlur={(e: any) => {
                                        if (e.target.value === '' || parseInt(e.target.value) <= 0) {
                                          setSaleItemList((prev: IAddSaleItemVM[]) => {
                                            let tempArray = [...prev];
                                            let filteredTreatmentItemList = tempArray.filter(
                                              (item: any) => item.ItemType !== serviceTypeEnum.Product
                                            );
                                            let filteredProductItemList = tempArray.filter(
                                              (item: any) => item.ItemType === serviceTypeEnum.Product
                                            );
                                            filteredProductItemList[index].Quantity = 1;
                                            return [
                                              ...filteredTreatmentItemList,
                                              ...filteredProductItemList,
                                            ];
                                          });
                                        }
                                      }}
                                    />
                                  </td>

                                  <td>
                                    <i className="bi bi-currency-yen me-1"></i>
                                    {formatNumberWithCommas((item.Price - item.TaxAmount)*item.Quantity)}
                                  </td>
                                  <td>
                                    <i className="bi bi-currency-yen me-1"></i>
                                    {formatNumberWithCommas((item.TaxAmount)*item.Quantity)} (
                                    {item.Tax}%)
                                  </td>
                                  <td>
                                    <i className="bi bi-currency-yen me-1"></i>
                                    {formatNumberWithCommas(itemPriceAfterDiscount*item.Quantity)}
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      disabled={
                                        viewOnly ? viewOnly : isDisabled
                                      }
                                      onClick={() =>
                                        addEditDiscountClickHandler(
                                          serviceTypeEnum.Product,
                                          index,
                                          item
                                        )
                                      }
                                      className="btn btn-link text-primary"
                                    >
                                      {item.DiscountType == 0 && (
                                        <>{item.DiscountPercent} %</>
                                      )}
                                      {item.DiscountType == 1 && (
                                        <><i className="bi bi-currency-yen me-1"></i>{formatNumberWithCommas(item.DiscountCash)}</>
                                      )}
                                      {item.DiscountType == 2 && (
                                        <>
                                          {item.DiscountPercent} % ,{" "}
                                          <><i className="bi bi-currency-yen me-1"></i>{formatNumberWithCommas(item.DiscountCash)}</>
                                        </>
                                      )}
                                    </button>
                                  </td>
                                  <td>
                                    <select
                                      className="ms-1 form-select max-input"
                                      value={item.StaffId}
                                      disabled={viewOnly ? viewOnly : isDisabled}
                                      onChange={(e: any) => {
                                        let selectedValue = parseInt(e.target.value) || 0;
                                        if (selectedValue) {
                                          setSaleItemList((prev: IAddSaleItemVM[]) => {
                                            let tempArray = [...prev];
                                            let filteredTreatmentItemList = tempArray.filter(
                                              (item: any) => item.ItemType !== serviceTypeEnum.Product
                                            );
                                            let filteredProductItemList = tempArray.filter(
                                              (item: any) => item.ItemType === serviceTypeEnum.Product
                                            );
                                            filteredProductItemList[index].StaffId = selectedValue;
                                            return [
                                              ...filteredTreatmentItemList,
                                              ...filteredProductItemList,
                                            ];
                                          });
                                          setIsDataChanged(true);
                                        }
                                      }}
                                    >
                                      {props.getAllStaffOptions.map(
                                        (op: IOption) => (
                                          <option
                                            key={op.id}
                                            value={op.id}
                                          >
                                            {op.label}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </td>
                                  <td className="text-end d-flex align-items-center justify-content-end">
                                    {!viewOnly && (
                                      <div className="btn-group">
                                        <button
                                          className="btn btn-outline-danger"
                                          type="button"
                                          disabled={isDisabled}
                                          onClick={() => {
                                            deleteProductSaleItemHandler(index);
                                          }}
                                        >
                                          <i className="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                      </tbody>
                    </table>
                  </div>

                  {/* Payment Information */}
                  <div className="py-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h3 className="mb-0">
                        <FormattedMessage id="payment_information" />
                      </h3>
                    </div>
                    <div className="border mt-3">
                      <SaleRecordPaymentInvoice
                        mainStaff={{ StaffId: values.StaffId, IsNominationApplied: values.IsNominationApplied }}
                        saleRecordItem={saleRecord}
                        isDataChanged={isDataChanged}
                        saleItems={saleItemList}
                        consumptionTax={consumptioTaxSetting}
                        overAllDiscountDetails={overAllDiscountDetail}
                        getAllStaffOptions={props.getAllStaffOptions}
                        onRemoveDiscount={handleRemoveDiscount}
                      />
                    </div>
                    <div className="row g-1 mt-2">
                      <div className="col-md-5 col-12">
                        {(saleRecord.SaleRecordPaymentStatus) && (
                          <>
                            <button
                              className="btn btn-secondary me-2"
                              type="button"
                              disabled={viewOnly ? viewOnly : saleRecord.PaymentType === 0}
                              onClick={() => {
                                setIsAddAccounting(false);
                                setOpenAccountingPopupSaleRecordId(saleRecord.Id)
                                accountingClickHandler();
                              }}
                            >
                              <FormattedMessage id="change_your_payment_method" />
                            </button>
                          </>
                        )}
                      </div>
                      <div className="col-md-3 col-12 text-center">
                        {saleRecord.SaleRecordPaymentStatus && (
                          <button
                            className="btn btn-secondary text-white"
                            type="button"
                            disabled={viewOnly ? viewOnly : isDisabled}
                          >
                            <FormattedMessage id="invoiced" />
                          </button>
                        )}
                        {!saleRecord.SaleRecordPaymentStatus &&
                          !registerSale && (
                            <button
                              className="btn btn-info btn-lg px-4 px-md-5"
                              type="button"
                              onClick={() => {
                                setIsAddAccounting(true);
                                if(isDataChanged)
                                  saleRecordSubmitHandler(values, true);
                                else
                                  props.accountingPopupToggleHandler();
                              }}
                              disabled={
                                viewOnly
                                  ? viewOnly
                                  : (isFutureDateOnly(saleRecord.Date) ? true : (selectedSaleRecrodForCreatingNewSale > 0 || (saleItemList?.length === 0 ? true : false)))
                              }
                            >
                              <FormattedMessage id="accounting" />
                            </button>
                          )}
                      </div>
                      <div className="col-md-4 col-12 text-end">
                        {!saleRecord.SaleRecordPaymentStatus &&
                          saleRecord.IsActiveRecord &&
                          selectedSaleRecrodForCreatingNewSale === -1 &&
                          !registerSale && (
                            <LoaderButton
                              type="submit"
                              iconName="bi-check-lg"
                              isLoading={false}
                              disabled={viewOnly ? viewOnly : (saleItemList?.length === 0 ? true : !isDataChanged)}
                              text="label_update"
                            />
                          )}
                        {saleRecord?.Id === -1 && !registerSale && (
                          <LoaderButton
                            type="submit"
                            iconName="bi-check-lg"
                            isLoading={false}
                            disabled={viewOnly ? viewOnly : (saleItemList?.length === 0 ? true : false)}
                            text="new_item"
                          />
                        )}
                        {registerSale && (
                          <LoaderButton
                            type="submit"
                            iconName="bi-check-lg"
                            disabled={viewOnly ? viewOnly : (saleItemList?.length === 0 ? true : !isDataChanged)}
                            isLoading={false}
                            text="add"
                          />
                        )}
                        {saleRecord.IsActiveRecord &&
                          !saleRecord.SaleRecordPaymentStatus &&
                          !registerSale &&
                          selectedSaleRecrodForCreatingNewSale === -1 && (
                            <Button
                              variant="outline-danger"
                              className="ms-2"
                              type="button"
                              onClick={() => deleteClickHandler()}
                              disabled={
                                viewOnly
                                  ? viewOnly
                                  : deleteSaleRecordState.inProgress
                              }
                            >
                              <FormattedMessage id="deletion" />
                            </Button>
                          )}
                        {saleRecord.IsActiveRecord &&
                          saleRecord.SaleRecordPaymentStatus === true &&
                          saleRecord.PaymentType === 0 &&
                          selectedSaleRecrodForCreatingNewSale === -1 && (
                            <Button
                              variant="info"
                              type="button"
                              disabled={viewOnly}
                              className="mx-2"
                              onClick={() =>
                                newSaleClickHandler(saleRecord.Id)
                              }
                            >
                              <FormattedMessage id="new_item" />
                            </Button>
                          )}
                        {saleRecord.SaleRecordPaymentStatus === true &&
                          saleRecord.PaymentType === 0 && (
                            <Button
                              variant="outline-danger"
                              type="button"
                              disabled={true}
                            >
                              <FormattedMessage id="refunded" />
                            </Button>
                          )}
                        {saleRecord.IsActiveRecord &&
                          saleRecord.SaleRecordPaymentStatus === true &&
                          saleRecord.PaymentType === 1 && (
                            <Button
                              variant="outline-danger"
                              type="button"
                              disabled={viewOnly || refundSaleRecordState.inProgress}
                              onClick={() => refundClickHandler()}
                            >
                              <FormattedMessage id="refund" />
                            </Button>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default RefundPopupHOC(
  AccountingPopupHOC(
    BarcodeScannerPopupHOC(
      DiscountPopupHOC(
        DeletePopupHOC(AddPopupHOC(observer(AddEditSaleRecordForm)))
      )
    )
  )
);
